/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Shared_Hosting_Dtos_UserDefinedFieldGrpcDto_UserDefinedFieldGrpcDto } from '../models/Wealthlane_Shared_Hosting_Dtos_UserDefinedFieldGrpcDto_UserDefinedFieldGrpcDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserDefinedFieldsService {

    /**
     * @param moduleIds 
     * @returns Wealthlane_Shared_Hosting_Dtos_UserDefinedFieldGrpcDto_UserDefinedFieldGrpcDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppUserDefinedFieldsUserDefinedFieldsByModuleId(
moduleIds?: Array<number>,
): CancelablePromise<Array<Wealthlane_Shared_Hosting_Dtos_UserDefinedFieldGrpcDto_UserDefinedFieldGrpcDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/user-defined-fields/user-defined-fields-by-module-id',
            query: {
                'moduleIds': moduleIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
